import { render, staticRenderFns } from "./CompanyUserForm.vue?vue&type=template&id=0283148b&"
import script from "./CompanyUserForm.vue?vue&type=script&lang=js&"
export * from "./CompanyUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports